(ns frontend.view.modals.curtains.merge-option-curtain.events
  (:require [frontend.actions.named-value :as named-value-actions]
            [frontend.state.current-session :as session]))

(defn merge! [pipelines selections-state victim-id modal-state close-modal! on-completed!]
  (swap! modal-state assoc :processing? true)
  (let [on-success! (fn []
                      (session/wait-for-entity-disable!
                       victim-id
                       (fn [_]
                         (swap! modal-state dissoc :processing?)
                         (on-completed! close-modal!))))
        on-error! (fn []
                    (swap! modal-state dissoc :processing?)
                    ;;TODO show error message
                    )]
    (if (empty? pipelines)
      (named-value-actions/*->merge! {:victim-id victim-id
                                      :target-id (:target-id @selections-state)}
                                     on-success!
                                     on-error!)
      (named-value-actions/*->merge-per-pipeline! {:victim-id            victim-id
                                                   :targets-per-pipeline @selections-state}
                                                  on-success!
                                                  on-error!))))
